module.exports = __webpack_public_path__ + "static/media/apple-pay.e1dedd08.svg";